import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import Modal, { MEDIUM_MODAL_WIDTH } from "@/dsComponents/Modal";
import { ModalBody, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { PersonOutlined } from "@dextech-ai/dex-design-system/icons";
import rem from '@/utils/rem';


const CardList = ({ item, index }) => {
	return (<div className="layout-card__content_row" key={index}>
		<div className="layout-card__content__text">
			{item?.name}
		</div>
	</div>)
}

const DataElementList = ({ flow }) => {
	return (flow && flow?.length > 0 ?
		flow?.map((itemObjValue, index) => (
			<CardList key={index} item={itemObjValue} index={index} />
		)) :
		<div className="layout-card__content_row">
			<div className="layout-card__content__text">
				No data element
			</div>
		</div>
	)
}

const PersonaInfoModal = ({ visible, hide, persona }) => {

	return (
		<Modal width={MEDIUM_MODAL_WIDTH} visible={visible} close={hide}>
			<ModalHeader icon={<PersonOutlined data-ds-color="primary-dark" />}>
				<ModalTitle>{persona?.name || "-"}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div className="persona-info-modal">
					<div className="persona-info-modal__description">
						{persona?.description || "-"}
					</div>
					<hr />
					<div className="persona-info-modal__title">
						Value Drivers
					</div>
					<div className="persona-info-modal__value">
						{
							persona?.keyvaluedrivers?.length > 0 ?
								persona?.keyvaluedrivers?.map((item, index) => (
									<div key={index} className="layout-card__content__text">
										{item}
									</div>
								))
								:
								<div className="layout-card__content__text">
									-
								</div>
						}
					</div>
					<hr />
					<div className="persona-info-modal__data-element">
						<div className="persona-info-modal__data-element-content">
							<div className="persona-info-modal__title ">
								Recommended to Contribute
							</div>
							<DataElementList flow={persona?.contributes} />
						</div>
						<div className="persona-info-modal__consume-data-element">
							<div className="persona-info-modal__title">
								Recommended to Consume
							</div>
							<DataElementList flow={persona?.consumes} />
						</div>
					</div>
				</div>
			</ModalBody>
		</Modal>
	)
};

export default PersonaInfoModal;
